import { ViewportScroller } from "@angular/common";
import { Component, HostListener } from "@angular/core";

@Component({
  selector: "app-tap-to-top",
  templateUrl: "./tap-to-top.component.html",
  styleUrls: ["./tap-to-top.component.scss"],
})
export class TapToTopComponent {

  public show: boolean = false;

  constructor(private readonly viewScroller: ViewportScroller) {}

  @HostListener("window:scroll", [])
  onWindowScroll() {
    const number =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    if (number > 600) {
      this.show = true;
    } else {
      this.show = false;
    }
  }

  tapToTop() {
    this.viewScroller.scrollToPosition([0, 0]);
  }
}
